import { type HTMLAttributes, type ReactNode } from "react";
import useGetVoucherCardShape, { type LineConfig, type LinesFn } from "../../../hooks/useCreateVoucherCardBackground/v1/useCreateVoucherCardBackground";
import useGetChildDims from "../../../hooks/useGetChildDims/v1/useGetChildDims";

type NotchType = {
  position: { x: number; y: number };
  radius: number;
};

type NamedPosition = {
  posX: "Left" | "Right" | "Center";
  posY: "Top" | "Bottom" | "Center";
  radius: number;
};

type BorderStyle = "solid" | "dashed" | "dotted" | "none";

export function VoucherCard({
  children,
  notches,
  positions,
  fillColor,
  borderColor,
  borderStyle,
  strokeWidth,
  borderRadius,
  lines,
  className,
  style,
  ...rest
}: {
  children: ReactNode;
  notches?: NotchType[];
  positions?: NamedPosition[];
  fillColor?: string;
  borderColor?: string;
  borderStyle?: BorderStyle;
  strokeWidth?: number;
  borderRadius?: number;
  lines?: LineConfig[] | LinesFn;
} & Omit<HTMLAttributes<HTMLDivElement>, "children">) {
  const { ref, src } = useGetVoucherCardShape({ notches, positions, fillColor, borderColor, borderStyle, strokeWidth, borderRadius, lines });
  const { ref: childRef } = useGetChildDims();

  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      className={className}
      style={{
        backgroundImage: src ? `url(${src})` : undefined,
        backgroundSize: "100% 100%",
        backgroundRepeat: "no-repeat",
        ...style,
      }}
      {...rest}
    >
      <div ref={childRef} style={{ width: "100%", height: "auto" }}>
        {children}
      </div>
    </div>
  );
}
